import Control from "../../../../../../common/Controls/Control";
import useRCPROQuestion from "./useRCPROQuestion";

const RCPROEducation = ({ company }) => {
  const { updateRcproData, onBlur, errors, inputsConfig, formState } =
    useRCPROQuestion({ company });
  return (
    <div>
      <Control
        label={inputsConfig.educationTypeFormation.label}
        type="checkBtnList"
        name="educationTypeFormation"
        value={company.RCPRO.educationTypeFormation}
        change={updateRcproData}
        error={errors}
        labelClassname="w-100"
        inputGroupStyle={{ width: "100%" }}
        btnInline
        datas={inputsConfig.educationTypeFormation.datas}
        dataIndex="id"
        dataLabel="name"
        onBlur={onBlur}
        required
        info={<>Plusieurs réponses possibles</>}
      />
      <Control
        label={inputsConfig.educationFormationCertifiante.label}
        type="btnList"
        name="educationFormationCertifiante"
        value={company.RCPRO.educationFormationCertifiante}
        change={updateRcproData}
        error={errors}
        labelClassname="w-100"
        inputGroupStyle={{ width: "100%" }}
        btnInline
        datas={inputsConfig.educationFormationCertifiante.datas}
        dataIndex="id"
        dataLabel="name"
        onBlur={onBlur}
        required
      />
      <Control
        label={inputsConfig.educationCertifieQualiopi.label}
        type="btnList"
        name="educationCertifieQualiopi"
        value={company.RCPRO.educationCertifieQualiopi}
        change={updateRcproData}
        error={errors}
        labelClassname="w-100"
        inputGroupStyle={{ width: "100%" }}
        btnInline
        datas={inputsConfig.educationCertifieQualiopi.datas}
        dataIndex="id"
        dataLabel="name"
        onBlur={onBlur}
        required
      />
    </div>
  );
};

export default RCPROEducation;
